module.exports = __webpack_public_path__ + "static/media/icon-footer-fb.547a1770.svg";